import { useState } from "react";
import { toast } from "sonner";
import { CreditCard, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export const isUnpaid = (b) => b?.payment_status === "awaiting_payment" && b?.status !== "cancelled";

export function UnpaidFlag({ testid }) {
  return (
    <span className="px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider bg-[#FF4500] text-white" data-testid={testid}>Unpaid</span>
  );
}

export function PayNowButton({ bookingId, price, className = "", testid }) {
  const [busy, setBusy] = useState(false);
  const pay = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setBusy(true);
    try {
      const { data } = await api.post(`/checkout/booking/${bookingId}`, { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Couldn't start payment");
      setBusy(false);
    }
  };
  return (
    <button type="button" onClick={pay} disabled={busy} data-testid={testid}
      className={`px-3 py-1.5 text-xs uppercase tracking-wider font-bold bg-[#CCFF00] text-black inline-flex items-center gap-1.5 hover:brightness-110 disabled:opacity-50 ${className}`}>
      {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <CreditCard className="w-3.5 h-3.5" />}
      Pay now{price ? ` · £${Number(price).toFixed(2)}` : ""}
    </button>
  );
}
